export function ParseHtml({ html }: { html?: string }) {
  const parts = html?.replaceAll('<BR>', '<br>').split('<br>') ?? []
  return parts.map((p, idx) => (
    <>
      {p}
      {idx < parts.length - 1 && <br />}
    </>
  ))
}
